import * as React from 'react';
import Axios from 'axios';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import NavbarHeader from 'src/components/header/NavbarHeader';
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import useQueryString from 'src/hooks/useQueryString';
import { getPtpPagos, getPtpListadoPagosPendientes } from 'src/services/urls';
import { useParams, useHistory } from 'react-router';

export interface IListadoPagosProps {
}
interface ParamTypes {
  empresa: string,
  ref: string
  finsuscripcion: string
}

export default function ListadoPagos(props: IListadoPagosProps) {

  const history = useHistory();
  const qParams = useQueryString();

  console.log("qParams", qParams)
  const params = useParams<ParamTypes>()
  console.log(params)
  const [products, setproducts] = React.useState([])

  React.useEffect(() => {

    const { empresa = '', ref = '' } = params


    let url = ""
    if (`${qParams.finsuscripcion}` === 'true')
      url = `${getPtpListadoPagosPendientes(ref, true)}`
    else url = `${getPtpPagos(ref, empresa)}`

    console.log(`${qParams.finsuscripcion}` === 'true', qParams.finsuscripcion, url)

    Axios.get(url).then(({ statusText, data }) => {
      if (statusText === "OK") {
        if (data?.transaccion) {
          if (`${qParams.finsuscripcion}` === 'true')
            setproducts(data?.hitorial ?? [])
          else setproducts(data?.data ?? [])
        }
      }
      console.log(data)


    });
  }, [])

  console.log("products:", history.location.pathname)
  return (
    <LoadingWrapper loading={false}>
      <NavbarHeader showBack={false} />


      {/* <NavbarHeader goBack={"()=>{}"} /> */}
      <div className="row justify-content-center mt-4">
        <div className="header__container col col-md-11 col-lg-10 text-center mt-4">
          <h3 className="header__producto__nombre font-weight-bold">
            <p className="header__producto__descripcion">
              Mis Pagos
            </p>
          </h3>
          <div className=" mt-4 col-xs-7 col-md-7 " style={{ margin: 'auto' }}>
            <img src="https://static.placetopay.com/placetopay-logo.svg" className="attachment-0x0 size-0x0" alt="" loading="lazy" style={{ maxWidth: 300 }} ></img>
          </div>
          <div className="mt-4" style={{ overflow: "scroll" }} >

            <DataTable value={products} paginator rows={15} emptyMessage="No existen datos" currentPageReportTemplate="{last} de {totalRecords}"
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport">
              <Column field="estado" header="Estado" ></Column>
              <Column field="fecha" header="Fecha"></Column>
              <Column field="monto" header="Monto (USD)"></Column>
              <Column field="numReference" header="Reference"></Column>
            </DataTable>
          </div>
        </div>
      </div>

    </LoadingWrapper>


  );
}
